import { SxProps, Theme } from "@mui/material";

const Styles: { [key:string]: SxProps<Theme> } = {
    Root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: '350px',
        fontSize: '16px',
        lineHeight: '20px'
    },
    SupportMenuContainer: {
        display: 'flex',
        justifyContent: 'center',
        width: '1000px'
    },
    SupportHeaderContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    SupportSectionHeader: {
        textAlign: 'center',
        textTransform: 'uppercase',
        marginBottom: '40px',
        letterSpacing: '1px',
        opacity: 0.6,
        '&:hover': {
            textDecoration: 'none',
            opacity: 1
        },
        color: 'white'
    },
    SupportLinkHeader: {
        textTransform: 'uppercase',
        cursor: 'pointer',
        opacity: 0.6,
        '&:hover': {
            textDecoration: 'none',
            opacity: 1
        },
        marginBottom: '10px',
        fontSize: '16px',
        lineHeight: '20px',
        color: 'white'
    },
    SupportLink: {
        cursor: 'pointer',
        opacity: 0.6,
        '&:hover': {
            textDecoration: 'none',
            opacity: 1
        },
        marginBottom: '10px',
        fontSize: '16px',
        lineHeight: '20px',
        color: 'white'
    },
    SupportLinksContainer: {
        display: 'flex',
        justifyContent: 'center',
        borderRight: '1px solid white'
    },
    SupportCategoryLinksContainer: {
        display: 'flex',
        flexDirection: 'column',
        marginRight: '32px',
        width: '200px'
    },
    TroubleshootLinksContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '200px'
    },
    HomeSectionHeader: {
        display: 'flex',
        flex: 1,
        justifyContent: 'center'
    },
    AboutLinksContainer: {
        display: 'flex',
        flexDirection: 'column'
    }
};

export default Styles;